// extracted by mini-css-extract-plugin
export default {"wrapper":"_D-z","viewport":"aE-z","container":"bE-z","slide":"cE-z"};